import { ClientDetails } from "src/app/site/feature-modules/profile/models/profile";


export class LoadClientDetails {
  static readonly type = '[ClientDetails] Load';
}

export class AddClientDetails {
  static readonly type = '[ClientDetails] Add';
  constructor(public payload: ClientDetails) {}
}

export class UpdateClientDetails {
  static readonly type = '[ClientDetails] Update';
  constructor(public payload: ClientDetails) {}
}

export class DeleteClientDetails {
  static readonly type = '[ClientDetails] Delete';
  constructor(public id: number) {}
}
